import { put, call, takeLatest } from 'redux-saga/effects'
import { FETCH_GUIDE } from './constants'
import { fetchGuide } from './actions'
import { fetchGuidesApi } from './services'

function* fetchGuideWorker(action) {
  const response = yield call(fetchGuidesApi, action.deviceId)

  if (response[0].children.length !== 0) {
    const guide = response[0].children.find(
      (guide) => guide.guideId === parseInt(action.guideId, 10)
    )
    yield put(fetchGuide.success(guide))
  }
}

export default function* watcher() {
  yield takeLatest(FETCH_GUIDE.REQUEST, fetchGuideWorker)
}
